export const Logo = ({ dark = false, className = "h-16" }) => (
  <img
    src="/logo-zari.png"
    alt="ZARI ENGENHARIA"
    data-testid="logo-mark"
    className={`${className} w-auto select-none ${dark ? "invert" : ""}`}
    draggable={false}
  />
);
